import Vue from 'vue'
import VueRouter from 'vue-router'
import storage from '@/utils/storage'

import { getCookie, removeCookie } from '@/utils'
Vue.use(VueRouter)

const routes = [{
    path: '',
    name: 'dashboard',
    component: () => import('../views/layouts/UserLayout.vue'),
    beforeEnter: (to, from, next) => {
        if (!getCookie('token')) {
            location.href = '/'
            return false
        }
        next()
    },
    redirect: '/match',
    children: [{
        path: '/match',
        name: 'match',
        title: '足球',
        component: () => import('../views/match/index.vue')
    }, {
        path: '/settings',
        name: 'settings',
        title: '设置',
        component: () => import('../views/settings/index.vue')
    }]
}, {
    path: '/user',
    name: 'User',
    component: () => import('../views/layouts/BlankLayout.vue'),
    redirect: '/user/login',
    children: [{
        path: '/user/login',
        name: 'login',
        component: () => import('../views/user/login.vue')
    }]
}]

const router = new VueRouter({
    // mode: "history",
    routes
})

export default router